import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { WidgetsService } from '../../widgets.service';
import { SearchItem } from '../../../../entities';
import { AppService } from '../../../../app.service';
import { FleetCondition } from '../../widgets.model';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs/Observable';
import { WidgetsEnlargedComponentComponent } from '../widgets-enlarged-component/widgets-enlarged-component.component';
import { TranslateService } from '../../../../translate';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'fleet-condition-widget',
    templateUrl: './fleet-condition-widget.component.html',
    styleUrls: ['./fleet-condition-widget.component.scss']
})
export class FleetConditionWidgetComponent implements OnInit, OnDestroy {
    private _subscriptions: Subscription[] = [];
    private _userLanguage: string = "english";
    @Input() chartid: string;
    @Input() passedDataSource: any;
    @Input() isInPopup: boolean = false;
    width: number = 280;
    height: number = 180;
    type: string = 'doughnut3d';
    dataFormat: string = 'json';
    dataSource: any;
    fleetCondition: FleetCondition;
    subscriptions: Subscription[] = [];
    //widgetTriggerSubscription: Subscription;
    emptySearchSelectionQuery: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" }];
    loading: boolean = true;
    noData: boolean = false;
   
    enableTab:boolean=false
    
    // We can use this to handle click events when a user interacts with the chart.
    // There is more documentation on this on the FusionCharts website. - Tom
    // https://www.fusioncharts.com/dev/using-with-javascript-libraries/angular4/including-interactivity-in-charts-using-angular4
    chartconfig: any = {
        events: {
            /***
            ** Slicing event of Pie Chart
            ***/
            slicingStart: function (evtObj, argObj) {
                console.log(evtObj, argObj);
            }
        }
    }

    constructor(private _widgets: WidgetsService,
        private _translate: TranslateService,
        private _app: AppService,
        private _ref: ChangeDetectorRef,
        private _notification: NotificationsService,
        private _dialog: MatDialog) {
        this.dataSource = {
            "chart": {
                "numberPrefix": "$",
                "paletteColors": "#6FCF97,#F2C94C,#F2994A,#EB5757,#4F4F4F",
                "bgColor": "#ffffff",
                "showBorder": "0",
                "use3DLighting": "0",
                "showShadow": "0",
                "enableSmartLabels": "0",
                "startingAngle": "310",
                "showLabels": "0",
                "showPercentValues": "1",
                "showLegend": "1",
                "legendShadow": "0",
                "legendBorderAlpha": "0",
                "decimals": "0",
                "theme": "zune",
                "captionFontSize": "14",
                "subcaptionFontSize": "14",
                "subcaptionFontBold": "0",
                "toolTipColor": "#ffffff",
                "toolTipBorderThickness": "0",
                "toolTipBgColor": "#000000",
                "toolTipBgAlpha": "80",
                "toolTipBorderRadius": "2",
                "toolTipPadding": "5",
                "useDataPlotColorForLabels": "1"
            },
            "data": [
                {
                    "label": "A",
                    "value": "0"
                },
                {
                    "label": "B",
                    "value": "0"
                },
                {
                    "label": "C",
                    "value": "0"
                },
                {
                    "label": "X",
                    "value": "0"
                },
                {
                    "label": "U",
                    "value": "0"
                },
            ]
        }
    }


    ngOnInit() {
        this.enableTab=this._app.getEnableSearch()
     
        this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));
        if (this.passedDataSource != null) {
            console.log("received   ", this.passedDataSource);
            this.subscriptions.push(
                this.passedDataSource.subscribe(r => this.loadDataToGraph(r))
                //  this.passedDataSource.forEach(c=>this.pushResult(c))
            );

            this.loading = false;
            if (this.isInPopup) {
                this.width = 460;
                this.height = 360;
            }
        }
        else {
            this.loadWidget(this._app.getLastSelectionSearchItems());
        }
    }

    updateUserLang(lang: string) {
        this._userLanguage = lang;
        this._ref.detectChanges();
      }
    ngOnDestroy() {
        this.subscriptions.forEach(s => {
            if (s != undefined && !s.closed)
                s.unsubscribe();
        });
        //this.widgetTriggerSubscription.unsubscribe();
    }
    dataSourceToPass: any;
    openWithANewPopup() {

        let dialogRef = this._dialog.open(WidgetsEnlargedComponentComponent, {
            panelClass: 'removeModalOverflow',
            data: {
                chartId: this.chartid,
                dataSource: this.dataSourceToPass,
                chartTitle: "Eval Overview",
            }
        });

        dialogRef.afterClosed().subscribe(r => {

        });
    }

    loadWidget(searchSelection: SearchItem[]) {
        this.loading = true;
        this.subscriptions.push(this._widgets.getFleetCondition(searchSelection).subscribe(r => {
            this.dataSourceToPass = Observable.of(r);
            this.loadDataToGraph(r);
        }, error => { this._notification.error('Error', 'Failed to load actions required. '); console.log(error); }));
    }



    loadDataToGraph(r) {
        this.dataSource.data[0].value = r.A;
        this.dataSource.data[1].value = r.B;
        this.dataSource.data[2].value = r.C;
        this.dataSource.data[3].value = r.X;
        this.dataSource.data[4].value = r.Unknown;
        if (r.A + r.B + r.C + r.X + r.Unknown == 0)
            this.noData = true;
        else
            this.noData = false;
        this.loading = false;
    }
}
